import { Cell } from "./Cell";
import { ReportStatusBadge } from "./ReportStatusBadge";
import { EvictionReportContent } from "./EvictionReportContent";
import { FullApplicant, Verification } from "../types";

interface EvictionReportCellProps {
  verification: Verification;
  applicant: FullApplicant;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportCell = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportCellProps) => {
  return (
    <Cell isDataCell className="relative">
      <EvictionReportContent
        verification={verification}
        applicant={applicant}
        hasAuditFlagEnabled={hasAuditFlagEnabled}
      />
      <ReportStatusBadge
        applicantStatus={applicant.application_status}
        verificationStatus={verification.status}
        executionMode={verification.settings?.execution_mode}
      />
    </Cell>
  );
};
